import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppStorage } from '../../enums/app-storage';
import { RoleTypes } from '../../constants/role-types.constant';
import { TenantService } from '../../services/tenant/tenant.service';
import { CookieService } from '../../services/cookie/cookie.service';
import { AUTH_ROUTES } from '../../constants/auth.routing.constants';
import { LogoutHelperService } from '../../helpers/logout-helper/logout-helper.service';

export const vendorAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tenantService = inject(TenantService);
  const cookieService = inject(CookieService);
  const logoutHelper = inject(LogoutHelperService);

  const isTokenPresent = !!cookieService.get(AppStorage.token);
  const role = cookieService.get(AppStorage.role);
  const parsedRole = role ? JSON.parse(role) : null;
  const isRoleVendor = parsedRole
    ? Array.isArray(parsedRole)
      ? parsedRole.includes(RoleTypes.VENDOR)
      : parsedRole.name === RoleTypes.VENDOR
    : false;

  if (!isTokenPresent) {
    const queryParamArray = location.search.replace('?', '').split('=');
    const queryParamObject = { [queryParamArray[0]]: queryParamArray[1] };
    logoutHelper.handleLogout();
    router.navigate([tenantService.authPath(AUTH_ROUTES.LOGIN)], {
      queryParams: {
        target: location.pathname,
        ...queryParamObject,
      },
    });
  }
  if (isTokenPresent && !isRoleVendor) {
    logoutHelper.handleLogout();
  }

  return isTokenPresent && isRoleVendor;
};
